import { useEffect } from 'react';
import client from 'apollo/client';

import useSubmitProgress from 'hooks/useSubmitProgress';
import {
  resetApplyStatusState,
  setMutationFailures,
  setShouldRunSubmit,
  useApplyStatusState,
} from './applyStatusState';

const SubmitAccountStatusStep = ({
  accountStatusMutation,
  setAccountFraudStatus,
  closeModal,
}) => {
  const { shouldRunSubmit, accountFraudStatusVariables } =
    useApplyStatusState();

  const submitProgressConfig = {
    steps: [
      {
        queries: [accountStatusMutation],
        text: 'Apply Account Status',
        errorMessage: `Failed to apply account status ${accountFraudStatusVariables?.reasonCode}. Please retry.`,
        errorTestId: 'status-mutation-failure-alert',
      },
    ],
    successMessage: `Account status ${accountFraudStatusVariables?.reasonCode} applied successfully.`,
    successTestId: 'account-status-success-message',
    onComplete: () => {
      setTimeout(() => {
        resetApplyStatusState();
        closeModal();
      }, 2000);
    },
    onSubmit: async ({ markInitiated, markCompleted, hasSubmittedRef }) => {
      try {
        setMutationFailures(false);
        markInitiated();

        let accountStatusResponse = accountStatusMutation;

        if (!accountStatusResponse?.data) {
          accountStatusResponse = await setAccountFraudStatus({
            variables: accountFraudStatusVariables,
          });
        }

        markCompleted();
        setShouldRunSubmit(false);
        hasSubmittedRef.current = false;

        accountFraudStatusVariables?.accountIds?.forEach((id) =>
          client.cache.evict({
            id: client.cache.identify({ __typename: 'Account', id }),
            fieldName: 'statusesRaw',
          }),
        );
        client.cache.gc();

        await client.refetchQueries({
          include: [
            'GetAccountStatusesRaw',
            'GetCustomerWithFullAccounts',
            'GetAccountStatementPreferences',
          ],
        });
      } catch (error) {
        console.error('Submit error:', error);
        throw error;
      }
    },
  };

  const {
    submissionInitiated,
    handleSubmit,
    renderProgress: renderSubmitProgress,
  } = useSubmitProgress(submitProgressConfig);

  useEffect(() => {
    if (shouldRunSubmit && !submissionInitiated) {
      handleSubmit();
    }
  }, [shouldRunSubmit, submissionInitiated, handleSubmit]);

  return <div>{submissionInitiated && renderSubmitProgress()}</div>;
};

export default SubmitAccountStatusStep;
